import { render, staticRenderFns } from "./messagesendgroup.vue?vue&type=template&id=2ed8be0c&scoped=true&"
import script from "./messagesendgroup.vue?vue&type=script&lang=ts&"
export * from "./messagesendgroup.vue?vue&type=script&lang=ts&"
import style0 from "./messagesendgroup.vue?vue&type=style&index=0&id=2ed8be0c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ed8be0c",
  null
  
)

component.options.__file = "messagesendgroup.vue"
export default component.exports